import { Injectable, signal, computed } from '@angular/core';

type Language = 'en' | 'no';

@Injectable({
  providedIn: 'root',
})
export class LanguageSignalService {
  private languageSignal = signal<Language>((localStorage.getItem('languageCulture') as Language) || 'en');

  currentLanguage = computed(() => this.languageSignal());

  setLanguage(lang: Language) {
    this.languageSignal.set(lang);
  }
}
